/**
 * Browser-facing API bases (deployed env uses full URLs from CI/CD build args).
 * Local dev: use /api/gateway/* with setupProxy.js (localhost or remote targets via env).
 */
export const GATEWAY_SDA_PREFIX = '/api/gateway/sda';
export const GATEWAY_RUNTIME_PREFIX = '/api/gateway/runtime';

export function getSdaApiBaseUrl() {
  const v = (process.env.REACT_APP_API_BASE_URL || '').trim();
  if (v) return v.replace(/\/$/, '');
  return GATEWAY_SDA_PREFIX;
}

export function getRuntimeApiBaseUrl() {
  const v = (process.env.REACT_APP_RUNTIME_API_BASE_URL || '').trim();
  if (v) return v.replace(/\/$/, '');
  return GATEWAY_RUNTIME_PREFIX;
}

/** APIM subscription key (build-time injected); null when unset (local dev). */
export function getApimSubscriptionKey() {
  return (process.env.REACT_APP_SUBS_KEY || '').trim() || null;
}
